<template>
  <b-card>
    <validation-observer
      ref="infoRules"
      v-slot="{ invalid }"
      tag="form"
    >
      <b-row>
        <b-col md="6">
          <!-- Name -->
          <validation-provider
            #default="validationContext"
            name="Name"
            rules="required"
          >
            <b-form-group
              label="Name of Group"
              label-for="Name of Group"
            >
              <b-form-input
                id="name"
                v-model="groupCerForm.name"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Name"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col md="12">
          <b-form-group
            label="Certificates in this group"
            label-for="certificates"
          >
            <v-select
              id="certificates"
              v-model="selectedCertificates"
              class="w-100"
              :options="certificateOptions"
              :loading="certificatesLoading"
              label="text"
              placeholder="Search and select certificates..."
              multiple
              :close-on-select="false"
            />
            <small class="text-muted">
              Selecting a certificate here moves it into this group (it is removed from any
              other group it was in). Deselecting removes it from this group only.
            </small>
          </b-form-group>
        </b-col>

        <!-- Server Errors -->
        <b-col
          v-if="Object.values(errors).length > 0"
          cols="12"
        >
          <p
            v-for="(error, key, index) in errors"
            :key="index"
            class="text-danger small"
          >
            {{ error.toString() }}
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          class="mt-50"
        >
          <b-button
            v-if="!loader && $route.params.id"
            variant="primary"
            class="mr-1"
            :disabled="invalid || Object.values(errors).length > 0"
            @click="addGroupCertificate()"
          >
            Save Changes
          </b-button>
          <b-button
            v-if="!loader && !$route.params.id"
            variant="primary"
            class="mr-1"
            :disabled="invalid || Object.values(errors).length > 0"
            @click="addGroupCertificate()"
          >
            Add
          </b-button>
          <b-button
            v-if="loader"
            variant="primary"
            disabled
            class="mr-1"
          >
            <b-spinner
              small
              type="grow"
            />
            Loading...
          </b-button>
        </b-col>
      </b-row>
    </validation-observer>
  </b-card>
</template>

<script>
import { ref } from '@vue/composition-api'
import formValidation from '@core/comp-functions/forms/form-validation'
import axios from 'axios'
import { required } from '@validations'
import VSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import decryptData from '@/store/auth/decryptData'

export default {
  components: {
    'v-select': VSelect,
  },
  data() {
    return {
      required,
      loader: false,
      validationErrors: {},
      errors: {},
      certificateOptions: [],
      certificatesLoading: false,
      selectedCertificates: [],
    }
  },
  setup() {
    const { getValidationState } = formValidation()
    // eslint-disable-next-line camelcase

    const groupCerForm = ref({
    })
    return {
      getValidationState,
      groupCerForm,
    }
  },
  mounted() {
    this.showGroupCertificate()
    this.getAllCertificates()
  },
  methods: {
    certificateLabel(item) {
      return `${item.name?.ar} - ${item.name?.en}`
    },

    async getAllCertificates() {
      this.certificatesLoading = true
      try {
        const res = await axios.get('certificate/get-sub')
        const data = decryptData(res.data.payload)?.data?.groups || []
        this.certificateOptions = data.map(item => ({
          value: item.id,
          text: this.certificateLabel(item),
        }))
      } catch (error) {
        this.showApiError(error, 'Could not load certificates')
      } finally {
        this.certificatesLoading = false
      }
    },

    showApiError(error, fallback = 'An unknown error occurred') {
      let errorMessage = fallback
      try {
        errorMessage = error.response.data.message || fallback
      } catch (e) {
        errorMessage = fallback
      }
      this.$toast({
        component: ToastificationContent,
        props: {
          title: errorMessage,
          icon: 'BellIcon',
          variant: 'danger',
        },
      })
    },

    showGroupCertificate() {
      if (this.$route.params.id) {
        axios.get(`certificate-categories/${this.$route.params.id}`).then(res => {
          const { data } = decryptData(res.data.payload)
          this.groupCerForm = { name: data.name }
          this.selectedCertificates = (data.certificates || []).map(item => ({
            value: item.id,
            text: this.certificateLabel(item),
          }))
        })
      } else {
        return false
      }
      return true
    },

    addGroupCertificate() {
      const formData = new FormData()
      formData.append('name', this.groupCerForm.name)
      this.selectedCertificates.forEach((item, index) => {
        formData.append(`certificate_ids[${index}]`, item.value)
      })

      if (this.$route.params.id) {
        this.loader = true
        formData.append('_method', 'PUT')

        axios
          .post(`certificate-categories/${this.$route.params.id}`, formData)
          .then(res => {
            if (res.status === 200) {
              this.$router.push({ name: 'group-certificate' })
              this.$toasted.show('Updated Successfully', {
                position: 'top-center',
                duration: 3000,
              })
            }
          })
          .catch(error => {
            if (error.response.status) {
              this.showApiError(error, 'Could not update group')
            }
          })
          .finally(() => {
            this.loader = false
          })
      } else {
        this.loader = true

        axios
          .post('certificate-categories', formData)
          .then(res => {
            if (res.status === 200 || res.status === 201) {
              this.$router.push({ name: 'group-certificate' })
              this.$toasted.show('Created Successfully', {
                position: 'top-center',
                duration: 3000,
              })
            }
          })
          .catch(error => {
            if (error.response.status) {
              this.showApiError(error, 'Could not create group')
            }
          })
          .finally(() => {
            this.loader = false
          })
      }
    },

  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
